import { CSSProperties } from "react"

export const StyleProps1: CSSProperties ={
    color: "white"
}

export const StyleProps3 : CSSProperties ={
    padding: "0px"
}

export const StyleProps2: CSSProperties ={
    backgroundColor: "#304aca"
}